export default "__VITE_ASSET__DnIU0$fv__"